module.exports = __webpack_public_path__ + "static/img/gtt.9252715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gtt.jpg
// module id = 8q1t
// module chunks = 1